// extracted by mini-css-extract-plugin
export default {"error":"error--wyDV1"};